import axios from 'axios';
import { get } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { FOXES_CREATE_BRIEF } from '../../../../../utils/experiments/experimentsEnum';
import { ALLOCATE_TO_EXPERIMENT, REDIRECT_TO_PAGE } from './constants';

const allocateToBriefsExperiment = async(pathfinderWrapper, logger) => {
    try {
        const allocateUrl = pathfinderWrapper.pathfinder(ALLOCATE_TO_EXPERIMENT);

        const { data } = await axios.post(allocateUrl);
        const variation = get(data, `${FOXES_CREATE_BRIEF}`);

        return Number(variation);
    } catch (error){
        logger.error(error, {
            description: 'Failed to call allocate to briefs experiment request'
        });
    }
};

const redirectToCreateBriefPage = (pathfinderWrapper) => {
    const { pathParameters } = getContext();
    const { username, slug } = pathParameters;

    const createBriefUrl = buildCreateBriefsUrl({ pathfinderWrapper, username, slug });

    redirect(createBriefUrl);
};

const buildCreateBriefsUrl = ({ pathfinderWrapper, username, slug }) =>
    pathfinderWrapper.pathfinder(REDIRECT_TO_PAGE, {}, {
        query: {
            username,
            gig_slug: slug
        }
    });

const redirect = (url) => {
    window.location.assign(url);
};

export {
    allocateToBriefsExperiment,
    redirectToCreateBriefPage
};
